import KendoButtonMixin from './KendoButtonMixin'

export default {
    name: 'kendo-button',
    mixins: [ KendoButtonMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/index.js